import React from 'react';
import { GetStaticProps } from 'next';
import Head from 'next/head';
import { Flex } from '@chakra-ui/react';
import sdk from '@src/lib/sdk';
import Navigation from '@components/Shared/Navigation/Navigation';
import { CategoryPostQuery } from '@src/generated/graphql';
import Category from '@components/Category';
import CookieConsentWrapper from '@components/Shared/CookieConsentWrapper/CookieConsentWrapper';

export interface InitData {
  categoryPosts: CategoryPostQuery['allPost'];
  categoryName: string;
}

export async function getStaticPaths() {
  const categories = await sdk.Categories();
  return {
    paths:
      categories.allPostCategory.map(({ slug }) => ({
        params: {
          category: slug?.current,
        },
      })) || [],
    fallback: true,
  };
}

export const getStaticProps: GetStaticProps<InitData> = async ({ params }) => {
  const categoryPosts = await sdk.CategoryPost({
    category: params?.category as string,
  });
  const category = await sdk.Category({
    slug: (params?.category as string) ?? '',
  });
  return {
    props: {
      categoryPosts: categoryPosts.allPost,
      categoryName: category.allPostCategory[0]?.title ?? '',
    },
  };
};

const CategoryPage: React.FC<InitData> = ({ categoryPosts, categoryName }) => {
  return (
    <CookieConsentWrapper>
      <Flex direction="column">
        <Head>
          <title>Ohsofree</title>
        </Head>
        <Navigation />
        <Category posts={categoryPosts} name={categoryName} />
      </Flex>
    </CookieConsentWrapper>
  );
};

export default CategoryPage;
